// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mWomUANiobSxlu2ljmLd{display:flex;flex-direction:column;gap:8px}", "",{"version":3,"sources":["webpack://./src/main/resources/public/signup/discount-form.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,OAAA","sourcesContent":[".discountForm {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"discountForm": "mWomUANiobSxlu2ljmLd"
};
export default ___CSS_LOADER_EXPORT___;
